"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeFilterOption = void 0;
const mobx_1 = require("mobx");
const vocabularies_1 = require("../../../vocabularies");
const products_1 = require("@getgreenline/products");
const metaDataHelpers_1 = require("../../../helpers/metaDataHelpers");
const quantityHelpers_1 = require("../../../helpers/quantityHelpers");
class RangeFilterOption {
    constructor() {
        this.setMin = (thc) => {
            this.min = thc;
        };
        this.setMax = (thc) => {
            this.max = thc;
        };
        this.reset = () => {
            this.min = undefined;
            this.max = undefined;
        };
        this.isInRange = (metaData) => {
            if (!this.singleValueKey) {
                throw new Error('singleValueKey is not set');
            }
            if (!this.minValueKey) {
                throw new Error('minValueKey is not set');
            }
            if (!this.maxValueKey) {
                throw new Error('maxValueKey is not set');
            }
            const showMaxMin = metaData[products_1.MetaDataModels.MetaDataReservedKeys.SHOW_MAX_MIN] === 'true';
            const thc = (0, metaDataHelpers_1.convertStrMetaDataToNumber)({
                metaData,
                key: this.singleValueKey,
            });
            const minThc = (0, metaDataHelpers_1.convertStrMetaDataToNumber)({
                metaData,
                key: this.minValueKey,
            });
            const maxThc = (0, metaDataHelpers_1.convertStrMetaDataToNumber)({
                metaData,
                key: this.maxValueKey,
            });
            return showMaxMin
                ? (0, quantityHelpers_1.compareRange)({
                    minEntity: minThc,
                    maxEntity: maxThc,
                    min: this.min,
                    max: this.max,
                })
                : (0, quantityHelpers_1.compareSingleValue)({
                    entity: thc,
                    min: this.min,
                    max: this.max,
                });
        };
        this.rangeMessage = (unit) => {
            if (!this.min && !this.max) {
                return;
            }
            const displayedUnit = unit || '';
            if (this.min && !this.max) {
                return `${this.min}${displayedUnit} ~ ${vocabularies_1.FilterVocabulary.UNLIMITED}`;
            }
            if (!this.min && this.max) {
                return `0${displayedUnit} ~ ${this.max}${displayedUnit}`;
            }
            return `${this.min || 0}${displayedUnit} ~ ${this.max || 0}${displayedUnit}`;
        };
    }
    get isSet() {
        return Boolean(this.min || this.max);
    }
}
exports.RangeFilterOption = RangeFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], RangeFilterOption.prototype, "min", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Number)
], RangeFilterOption.prototype, "max", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], RangeFilterOption.prototype, "setMin", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], RangeFilterOption.prototype, "setMax", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], RangeFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], RangeFilterOption.prototype, "isSet", null);
//# sourceMappingURL=RangeFilterOption.js.map